// removeUpdateAssignment — VQE-Edit edit-action: drop a SET assignment by
// 0-based list index via SR-Edit's `remove-update-assignment` op. SR-Edit
// handles the comma-stripping; this module only validates the index against
// an optional structure and delegates to `commitEdit`.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — DML edits.

import type { QueryStructure } from '../../../../sql-resolver/types/queryStructure';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

export type RemoveUpdateAssignmentOptions = {
  /** Optional structure used for index-bounds validation. */
  readonly structure?: QueryStructure;
};

export async function removeUpdateAssignment(
  index: number,
  ctx: CommitEditCtx,
  options: RemoveUpdateAssignmentOptions = {},
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(
      `removeUpdateAssignment: index must be a non-negative integer (got ${index})`,
    );
  }
  if (options.structure) {
    const items = options.structure.updateAssignments ?? [];
    if (items.length === 0) {
      throw new Error('removeUpdateAssignment: SET list is empty');
    }
    if (index >= items.length) {
      throw new Error(
        `removeUpdateAssignment: index ${index} out of range (SET list has ${items.length} item(s))`,
      );
    }
  }
  await commitEdit({ op: 'remove-update-assignment', index }, ctx);
}
